import { ReactElement } from 'react';
import DashboardWrapper from './DashboardWrapper';
import Users from '../screens/protected/Users';
import ChangePassword from '../screens/protected/ChangePassword';
import Tickets from '../screens/protected/Tickets';
import Category from '../screens/protected/Category';
import TailorPrice from '../screens/protected/tailor-master/index';
import Permission from '../screens/protected/Setting/Permission';
import Login from '../screens/public/Login';
import NotFound from '../screens/NotFound';
import FaceCapture from '../components/FaceCapture';
import RegisterFace from '../components/RegisterFace';
import Organization from '../screens/protected/organization-master/index';
import Modules from '../screens/protected/module/index';
import SubscriptionMaster from '../screens/protected/subscription-master/index';
import Profile from '../screens/protected/profile/index';
import Setting from '../screens/protected/Setting/Setting/index';
import PaymentSettings from '../screens/protected/Setting/PaymentSettings/index';
import SmsSettings from '../screens/protected/Setting/SmsSettings/index';
import WhatsappSettings from '../screens/protected/Setting/WhatsappSettings/index';
import EmailSettings from '../screens/protected/Setting/EmailSettings/index';
import IdCardMaster from '../screens/protected/aes/idcard-master/index';


import Products from '../screens/protected/products';
import HandicraftProducts from '../screens/protected/products/handicraft-products';
import FabricTypes from '../screens/protected/masters/fabric-types/index'
import FabricPatterns from '../screens/protected/masters/fabric-pattern'
import SaleTypes from '../screens/protected/masters/sale-types/index'
import Pn from '../screens/protected/masters/quality-names/index'
import Pnrs from '../screens/protected/masters/quality-numbers'
import ProductNames from '../screens/protected/masters/product-names/index'
import ProductInfo from '../screens/protected/masters/product-info/index'
import ProductUses from '../screens/protected/masters/product-uses/index'
import Caring from '../screens/protected/masters/caring/index'
import LeadMaster from '../screens/protected/front-desk/student-leads/index'
import GatePass from '../screens/protected/front-desk/gate-pass/index'
import GeneralEnquiry from '../screens/protected/front-desk/general-enquiry/index'
import Holidays from '../screens/protected/masters/holiday/index';
import Attendance from '../screens/protected/attendance/index';


import Template from '../screens/protected/masters/template-master/index'
import BrandNames from '../screens/protected/masters/brand-names/index';
// import FabricType from '../screens/protected/masters/fabric-type/index';
import ProductGradesindex from '../screens/protected/masters/product-grades/index';
// import ProductUses from '../screens/protected/masters/product-uses/index';
// import QualityName from '../screens/protected/masters/quality-names/index';
// import SaleType from '../screens/protected/masters/sale-types/index';


import Size from '../screens/protected/masters/sizes/index';
import BookNumbers from '../screens/protected/masters/booknumber';
import CardNumbers from '../screens/protected/masters/cardnumber';
import RackNumbers from '../screens/protected/masters/racknumber';
import BlockNumbers from '../screens/protected/masters/blocknumber';
import Places from '../screens/protected/masters/places';


import Pages from '../screens/protected/WebMaster/Pages/index'

import Vouchers from '../screens/protected/voucher';
import Vouchers2 from '../screens/protected/vouchers-2';
import POS from '../screens/protected/Billing/pos';
import Billing from '../screens/protected/Billing';


import Client from '../screens/protected/client'
import Width from '../screens/protected/masters/widths'
import WoodType from '../screens/protected/masters/wood-types'
import WoodMaster from '../screens/protected/masters/woods'
import HSNCode from '../screens/protected/masters/hsn-codes'
import Finish from '../screens/protected/masters/finishes'
import Composition from '../screens/protected/masters/compositions'
import Count from '../screens/protected/masters/counts'
import SubColor from '../screens/protected/masters/sub-colors'
import BaseColor from '../screens/protected/masters/base-colors'
import InspectionTailoring from '../screens/protected/masters/inspection-tailorings'
import PriceFormula from '../screens/protected/masters/price-formulas'
import ShadeNumber from '../screens/protected/masters/shade-numbers'
import UnitTypes from '../screens/protected/masters/unit-types'
import GST from '../screens/protected/masters/gst'

import CreateProduct from '../screens/protected/products/create-product'

// accounts 
import AccountHeads from '../screens/protected/accounts/account-heads'
import Legders from '../screens/protected/accounts/ledger'

import QuickRegistration from '../screens/public/QuickRegistration';

import Sleeves from '../screens/protected/masters/sleeve';
import Pockets from '../screens/protected/masters/pocket';
import Fits from '../screens/protected/masters/fit';

import CollarsPage from '../screens/protected/masters/collars';
import ButtonsPage from '../screens/protected/masters/buttons';
import CuffsPage from '../screens/protected/masters/cuffs';
import Plackets from '../screens/protected/masters/plackets';
import BackDetailsPage from '../screens/protected/masters/backdetails';
import Blogs from '../screens/protected/WebMaster/Blogs';
import Payrolls from '../screens/protected/accounts/payrolls';
import BodyShape from '../screens/protected/body-shape';

// Handicrafts 
import PurchaseOrder from '../screens/protected/handicraft/purchase-order/index';
import PartyNapi from '../screens/protected/handicraft/purchase-order/party-napi';




// Define route shape
interface AppRoute {
  path: string;
  element: ReactElement;
  protected: boolean;
}

export const routes: AppRoute[] = [
  {
    path: '/',
    element: <DashboardWrapper />,
    protected: true,
  },
  {
    path: '/users',
    element: <Users />,
    protected: true,
  },
  {
    path: '/tickets',
    element: <Tickets />,
    protected: true,
  },
  {
    path: '/category',
    element: <Category />,
    protected: true,
  },
  {
    path: '/tailor-price',
    element: <TailorPrice />,
    protected: true,
  },
  {
    path: '/permissions',
    element: <Permission />,
    protected: true,
  },
  {
    path: '/login',
    element: <Login />,
    protected: false,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
    protected: true,
  },
  {
    path: '/face',
    element: <FaceCapture />,
    protected: false,
  },
  {
    path: '/register-face',
    element: <RegisterFace />,
    protected: false,
  },
  {
    path: '/organization',
    element: <Organization />,
    protected: true,
  },
  {
    path: '/modules',
    element: <Modules />,
    protected: true,
  },
  {
    path: '/subscription',
    element: <SubscriptionMaster />,
    protected: true,
  },
  {
    path: '/profile',
    element: <Profile />,
    protected: true,
  },
  {
    path: '/setting',
    element: <Setting />,
    protected: true,
  },
  {
    path: '/payment-setting',
    element: <PaymentSettings />,
    protected: true,
  },
  {
    path: '/sms-setting',
    element: <SmsSettings />,
    protected: true,
  },
  {
    path: '/whatsapp-setting',
    element: <WhatsappSettings />,
    protected: true,
  },
  {
    path: '/email-setting',
    element: <EmailSettings />,
    protected: true,
  },
  {
    path: '/idcard-master',
    element: <IdCardMaster />,
    protected: true,
  },
  {
    path: '/products',
    element: <Products />,
    protected: true,
  },
  {
    path: '/handicraft-products',
    element: <HandicraftProducts />,
    protected: true,
  },
  {
    path: '/templates',
    element: <Template />,
    protected: true,
  },
  {
    path: '/brand-names',
    element: <BrandNames />,
    protected: true,
  },
  {
    path: '/caring',
    element: <Caring />,
    protected: true,
  },
  {
    path: '/fabric-types',
    element: <FabricTypes />,
    protected: true,
  },
  {
    path: '/fabric-patterns',
    element: <FabricPatterns />,
    protected: true,
  },
  {
    path: '/sizes',
    element: <Size />,
    protected: true,
  },
  {
    path: '/sale-types',
    element: <SaleTypes />,
    protected: true,
  },
  {
    path: '/product-grades',
    element: <ProductGradesindex />,
    protected: true,
  },
  {
    path: '/quality-names',
    element: <Pn />,
    protected: true,
  },
  {
    path: '/quality-numbers',
    element: <Pnrs />,
    protected: true,
  },
  {
    path: '/product-info',
    element: <ProductInfo />,
    protected: true,
  },
  {
    path: '/product-uses',
    element: <ProductUses />,
    protected: true,
  },
  {
    path: '/holidays',
    element: <Holidays />,
    protected: true,
  },
  {
    path: '/book-number',
    element: <BookNumbers />,
    protected: true,
  },
  {
    path: '/card-number',
    element: <CardNumbers />,
    protected: true,
  },
  {
    path: '/rack-number',
    element: <RackNumbers />,
    protected: true,
  },
  {
    path: '/block-number',
    element: <BlockNumbers />,
    protected: true,
  },
  {
    path: '/places',
    element: <Places />,
    protected: true,
  },
  {
    path: '/attendance',
    element: <Attendance />,
    protected: true,
  },
  {
    path: '/leads',
    element: <LeadMaster />,
    protected: true,
  },
  {
    path: '/general-enquiry',
    element: <GeneralEnquiry />,
    protected: true,
  },
  {
    path: '/gate-pass',
    element: <GatePass />,
    protected: true,
  },
  {
    path: '/pages',
    element: <Pages />,
    protected: true,
  },
  {
    path: '/vouchers',
    element: <Vouchers />,
    protected: true,
  },
  {
    path: '/vouchers-2',
    element: <Vouchers2 />,
    protected: true,
  },
  {
    path: '/pos',
    element: <POS />,
    protected: true,
  },
  {
    path: '/billing',
    element: <Billing />,
    protected: true,
  },
  {
    path: '/clients',
    element: <Client />,
    protected: true,
  },
  {
    path: '/widths',
    element: <Width />,
    protected: true,
  },
  {
    path: '/wood-types',
    element: <WoodType />,
    protected: true,
  },
  {
    path: '/woods',
    element: <WoodMaster />,
    protected: true,
  },
  {
    path: '/hsn-codes',
    element: <HSNCode />,
    protected: true,
  },
  {
    path: '/finishes',
    element: <Finish />,
    protected: true,
  },
  {
    path: '/compositions',
    element: <Composition />,
    protected: true,
  },
  {
    path: '/counts',
    element: <Count />,
    protected: true,
  },
  {
    path: '/sub-colors',
    element: <SubColor />,
    protected: true,
  },
  {
    path: '/base-colors',
    element: <BaseColor />,
    protected: true,
  },
  {
    path: '/inspection-tailorings',
    element: <InspectionTailoring />,
    protected: true,
  },
  {
    path: '/price-formulas',
    element: <PriceFormula />,
    protected: true,
  },
  {
    path: '/shade-numbers',
    element: <ShadeNumber />,
    protected: true,
  },
  {
    path: '/unit-types',
    element: <UnitTypes />,
    protected: true,
  },
  {
    path: '/gsts',
    element: <GST />,
    protected: true,
  },
  {
    path: '/create-products/:product_id?',
    element: <CreateProduct />,
    protected: true,
  },
  // account 
  {
    path: '/account-heads',
    element: <AccountHeads />,
    protected: true,
  },
  {
    path: '/ledgers',
    element: <Legders />,
    protected: true,
  },
  {
    path: '/quick-registration',
    element: <QuickRegistration />,
    protected: false,
  },
  {
    path: '/sleeves',
    element: <Sleeves />,
    protected: true,
  },
  {
    path: '/pockets',
    element: <Pockets />,
    protected: true,
  },
  {
    path: '/fit',
    element: <Fits />,
    protected: true,
  },
  {
    path: '/back-detail',
    element: <BackDetailsPage />,
    protected: true,
  },
  {
    path: '/plackets',
    element: <Plackets />,
    protected: true,
  },
  {
    path: '/cuffs',
    element: <CuffsPage />,
    protected: true,
  },
  {
    path: '/buttons',
    element: <ButtonsPage />,
    protected: true,
  },
  {
    path: '/collars',
    element: <CollarsPage />,
    protected: true,
  },
  {
    path: '/blogs',
    element: <Blogs />,
    protected: true,
  },
  {
    path: '/payrolls',
    element: <Payrolls />,
    protected: true,
  },
  {
    path: '/body-shape',
    element: <BodyShape />,
    protected: true,
  },
  {
    path: '/purchase-order',
    element: <PurchaseOrder />,
    protected: true,
  },
  {
    path: '/party-napi/:id',
    element: <PartyNapi />,
    protected: true,
  },
  {
    path: '*',
    element: <NotFound />,
    protected: false,
  },
];
